module.exports = __webpack_public_path__ + "media/images/responsive/logo/logo_eight_white-144b521cc9679b01fe639ce182351d8f.svg";